import { fasBadgeCheck } from 'shared/@generated/icons/fasBadgeCheck';
import { useTranslation } from 'react-i18next';
import { Animal, BreedType } from 'shared/@types';
import { Tooltip } from 'shared/components/tooltip';
import { getPurebredBadgeLabelKey } from 'shared/library/listing-breed-type';

const PurebredBadge = ({
  animal,
  breedType,
  hasVerifiedPedigree,
  className = 'size-4',
}: {
  animal: Animal | null;
  breedType: BreedType;
  hasVerifiedPedigree: boolean;
  className?: string;
}) => {
  const { t } = useTranslation('components');

  if (breedType !== BreedType.Purebred) {
    return null;
  }

  const label = t(
    `listing_breed_type_badge.${getPurebredBadgeLabelKey(animal, hasVerifiedPedigree)}`,
  );
  const [width, height, name, path] = fasBadgeCheck.definition;

  return (
    <Tooltip content={label} inline testID={'purebred-badge'}>
      <svg
        className={`shrink-0 text-blue-500 ${className}`}
        viewBox={`0 0 ${width} ${height}`}
        data-icon={name}
        aria-hidden="true"
      >
        <path fill="currentColor" d={path} />
      </svg>
    </Tooltip>
  );
};

export { PurebredBadge };
